<template>
    <LsInfoRow
        class="ls-info-row-frequency"
        :left-image="require('./assets/frequency.svg')"
        label="Frequency"
        :value="schedule.cycle | frequency"
    >
        <v-popover v-if="schedule.last_schedule_cycle_change" test-id="pop-over">
            <img :src="require('../../assets/info.svg')" />
            <template slot="popover">
                <div class="ls-info-row-frequency--popover">
                    <div>
                        <span>Old frequency:</span>
                        <span>{{
                            schedule.last_schedule_cycle_change.cycle_before | frequency
                        }}</span>
                    </div>
                    <div>
                        <span>Old price per service:</span>
                        <span
                            >{{
                                schedule.last_schedule_cycle_change.amount_price_before | currency
                            }}
                            + T&S Fee + Tax</span
                        >
                    </div>
                    <div>
                        <span>Changed by:</span>
                        <span
                            >{{ schedule.last_schedule_cycle_change.user | fullName }}
                            {{
                                schedule.last_schedule_cycle_change.user.is_admin
                                    ? '(Admin)'
                                    : '(Customer)'
                            }}</span
                        >
                    </div>
                    <div>
                        <span>Changed on:</span>
                        <span>{{ time }}</span>
                    </div>
                </div>
            </template>
        </v-popover>
    </LsInfoRow>
</template>

<script>
import VueTypes from 'vue-types';
import LsInfoRow from '../LsInfoRow/LsInfoRow.vue';
import { lsHelpers } from '@/helpers';

export default {
    name: 'LsInfoRowFrequency',
    components: {
        LsInfoRow,
    },
    props: {
        schedule: VueTypes.shape({
            last_schedule_cycle_change: VueTypes.oneOfType([
                VueTypes.shape({
                    cycle_before: VueTypes.number.isRequired,
                    amount_price_before: VueTypes.number.isRequired,
                    amount_tax_before: VueTypes.number.isRequired,
                    amount_total_before: VueTypes.number.isRequired,
                    created_at: VueTypes.string.isRequired,
                    user: VueTypes.shape({
                        id: VueTypes.string.isRequired,
                        is_admin: VueTypes.bool.isRequired,
                        first_name: VueTypes.string.isRequired,
                        last_name: VueTypes.string.isRequired,
                    }).isRequired.loose,
                }).isRequired.loose,
                VueTypes.oneOfType([null]),
            ]),
        }).isRequired.loose,
    },
    computed: {
        time() {
            const { created_at } = this.schedule.last_schedule_cycle_change;

            return lsHelpers.parseTimestamp({ timestamp: created_at });
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-info-row-frequency--popover {
    width: 240px;
    div {
        display: flex;
        flex-direction: column;
        font-weight: $medium;
        span:first-child {
            font-weight: $bold;
            color: $secondary-dark;
        }

        span:last-child {
            font-weight: $light;
            padding: 3px 0 5px 0;
        }
    }
    div:not(:last-child) {
        margin-bottom: 5px;
    }
}
</style>
